import { Paragraph } from 'docx';

// Utils
import { isEmptyValueArray } from '@shared/utils';
import { buildEducationLine } from '@/utils/resume';
import { bodyRun, sectionHeading, sectionSpacer } from '../utils';

// Types
import { TemplateProps } from '@/components/template/resume/type';

// Tokens
import { SECTION_TITLES } from '../../tokens';

// Constants
import { LINE_SPACING } from '../constants';

export const EducationSection = (
  educations: TemplateProps['data']['educations'],
): Paragraph[] => {
  if (!educations || isEmptyValueArray(educations)) return [];

  const paragraphs: Paragraph[] = [sectionHeading(SECTION_TITLES.education)];

  for (const education of educations) {
    const {
      school = '',
      graduation = '',
      degree = '',
      major = '',
    } = education ?? {};

    const educationLine = buildEducationLine(school, degree, major, graduation);

    if (educationLine) {
      paragraphs.push(
        new Paragraph({
          spacing: { line: LINE_SPACING },
          children: [bodyRun(educationLine)],
        }),
      );
    }
  }

  paragraphs.push(sectionSpacer());

  return paragraphs;
};
